import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/Onboard_1.png'
import _imports_1 from '../assets/img/Onboard_2.png'
import _imports_2 from '../assets/img/Onboard_3.png'


const _withScopeId = n => (_pushScopeId("data-v-440b9348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view onboarding" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slider__image slider__image-1",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" Burngram - "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" платформа для "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" создания цифрового "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" контента ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slider__image slider__image-2",
  src: _imports_1
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Создавай", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Твори с помощью нейросети и зарабатывай реальные деньги", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slider__image slider__image-3",
  src: _imports_2
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Публикуй", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Собирай лайки, будь активным и стань известным автором", -1))

import { useRouter } from 'vue-router';
import BaseSlider from '@/components/shared/BaseSlider.vue';
import { OnboardSevice } from '@/services/OnboardService';


export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeView',
  setup(__props) {

const router = useRouter();
function onFinish() {
	// Update onboard state
	OnboardSevice.welcomeState = { finished: true };
	OnboardSevice.onboardTabsState = { finished: false };
	OnboardSevice.onboardTourState = { finished: false, step: 0 };

	// Redirect to feed
	router.push('/');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseSlider, {
      onFinish: onFinish,
      slides: 3,
      "use-toggle": true,
      "use-next-button": true
    }, {
      "1": _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      "2": _withCtx(() => [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]),
      "3": _withCtx(() => [
        _hoisted_7,
        _hoisted_8,
        _hoisted_9
      ]),
      _: 1
    })
  ]))
}
}

})